<template>
  <transition name="rms-fade">
    <div v-if="show" class="rms-overlay" @click.self="$emit('close')">
      <transition name="rms-slide" appear>
        <div class="rms-panel">

          <div class="rms-header">
            <span class="rms-header__title">Mais opções</span>
            <button aria-label="Fechar" class="rms-close" @click="$emit('close')">
              <span class="material-symbols-outlined">close</span>
            </button>
          </div>

          <nav class="rms-list">
            <router-link
              v-for="item in items"
              :key="item.to"
              :to="item.to"
              class="rms-item"
              :class="{ 'rms-item--active': item.to === route.path }"
              @click="$emit('close')"
            >
              <span class="material-symbols-outlined rms-item__icon">{{ item.icon }}</span>
              <span class="rms-item__label">{{ item.label }}</span>
              <span v-if="item.to === route.path" class="rms-item__here">
                <span class="material-symbols-outlined">check_circle</span>
                Você está aqui
              </span>
              <span v-else class="material-symbols-outlined rms-item__chevron">chevron_right</span>
            </router-link>
          </nav>

        </div>
      </transition>
    </div>
  </transition>
</template>

<script setup>
import { useRoute } from 'vue-router'

defineProps({
  show: { type: Boolean, required: true },
})

defineEmits(['close'])

const route = useRoute()

// Mesmas rotas/ícones/labels do grupo "Representante" em AppSidebar.vue —
// única fonte já existente pra essas 3 telas exclusivas.
const items = [
  { to: '/ChamadaRepresentante',            icon: 'how_to_reg',          label: 'Chamada'                },
  { to: '/RegistrarPagamentoRepresentante', icon: 'payments',            label: 'Registrar Pagamento'    },
  { to: '/GerarPassagemRepresentante',      icon: 'confirmation_number', label: 'Passagem de Passageiro' },
]
</script>

<style scoped>
.rms-overlay {
  position: fixed;
  inset: 0;
  z-index: 300;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-end;
}

.rms-panel {
  width: 100%;
  background: var(--color-bg-card, #fff);
  border-radius: 1rem 1rem 0 0;
  box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.18);
  padding-bottom: env(safe-area-inset-bottom, 0);
  display: flex;
  flex-direction: column;
}

.rms-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem 0.75rem;
  border-bottom: 1px solid var(--color-border-light, #f1f5f9);
}
.rms-header__title {
  font-size: 0.9375rem;
  font-weight: 700;
  color: var(--color-text-dark, #0f172a);
}
.rms-close {
  background: none;
  border: none;
  cursor: pointer;
  color: #94a3b8;
  display: flex;
  align-items: center;
  padding: 4px;
  border-radius: 6px;
  transition: background 0.15s, color 0.15s;
}
.rms-close:hover { background: #f1f5f9; color: #0f172a; }

.rms-list {
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0.75rem 1rem;
}

.rms-item {
  display: flex;
  align-items: center;
  gap: 0.875rem;
  padding: 0.875rem 0.75rem;
  border-radius: 0.75rem;
  text-decoration: none;
  color: var(--color-text-dark, #0f172a);
  transition: background 0.15s;
}
.rms-item:hover {
  background: var(--color-bg-light, #f3f5ff);
}
.rms-item__icon {
  font-size: 1.35rem;
  color: var(--color-brand, #1A4BB8);
  flex-shrink: 0;
}
.rms-item__label {
  font-size: 0.9375rem;
  font-weight: 600;
  flex: 1;
}
.rms-item__chevron {
  font-size: 1.15rem;
  color: var(--color-text-soft, #cbd5e1);
  flex-shrink: 0;
}

/* Página atual — destaque bem mais evidente que um simples hover */
.rms-item--active {
  background: var(--color-brand-muted, rgba(29, 78, 216, 0.1));
  cursor: default;
}
.rms-item--active .rms-item__label { color: var(--color-brand, #1A4BB8); }
.rms-item__here {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.6875rem;
  font-weight: 700;
  color: var(--color-brand, #1A4BB8);
  flex-shrink: 0;
  white-space: nowrap;
}
.rms-item__here .material-symbols-outlined { font-size: 1rem; }

/* Overlay fade */
.rms-fade-enter-active,
.rms-fade-leave-active { transition: opacity 0.2s ease; }
.rms-fade-enter-from,
.rms-fade-leave-to { opacity: 0; }

/* Painel — desliza de baixo pra cima */
.rms-slide-enter-active,
.rms-slide-leave-active { transition: transform 0.25s ease; }
.rms-slide-enter-from,
.rms-slide-leave-to { transform: translateY(100%); }

[data-theme="dark"] .rms-panel { background: var(--color-bg-card, #0D1B3E); }
[data-theme="dark"] .rms-header { border-bottom-color: rgba(255,255,255,0.08); }
[data-theme="dark"] .rms-header__title { color: #e2e8f0; }
[data-theme="dark"] .rms-item { color: #e2e8f0; }
[data-theme="dark"] .rms-item:hover { background: rgba(255,255,255,0.06); }
[data-theme="dark"] .rms-item__chevron { color: rgba(255,255,255,0.25); }
[data-theme="dark"] .rms-item--active { background: var(--color-brand-muted, rgba(59,130,246,0.18)); }
[data-theme="dark"] .rms-item--active .rms-item__label,
[data-theme="dark"] .rms-item__here { color: var(--color-brand-light, #93c5fd); }
</style>
